import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdjusterImageIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 40,
	viewBox: "0 0 41 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20.6133,
			cy: 20,
			r: 20,
			fill: "#FEF3E9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.6133 20C23.3747 20 25.6133 17.7614 25.6133 15C25.6133 12.2386 23.3747 10 20.6133 10C17.8519 10 15.6133 12.2386 15.6133 15C15.6133 17.7614 17.8519 20 20.6133 20Z",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0234 30C12.0234 26.13 15.8735 23 20.6135 23",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8133 29.4C28.5806 29.4 30.0133 27.9673 30.0133 26.2C30.0133 24.4327 28.5806 23 26.8133 23C25.046 23 23.6133 24.4327 23.6133 26.2C23.6133 27.9673 25.046 29.4 26.8133 29.4Z",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.6133 30L29.6133 29",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAdjusterImageIcon;
